import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GET_ENTITY_SCHEMA, getPageQuery } from '../application/query';
import getErrorMessage from './get-error-message';
const getPageData = async ({
  apolloClient,
  itemId,
  itemEntity,
  isPreview = true
}) => {
  try {
    const {
      data: {
        entitySchema
      }
    } = await apolloClient.query({
      query: GET_ENTITY_SCHEMA,
      variables: {
        id: itemEntity
      }
    });
    const {
      data
    } = await apolloClient.query({
      query: getPageQuery(_objectSpread(_objectSpread({}, entitySchema), {}, {
        isPreview
      })),
      variables: {
        id: itemId
      }
    });
    return data;
  } catch (error) {
    return getErrorMessage(error);
  }
};
export default getPageData;
//# sourceMappingURL=get-page-data.js.map